import { SubscriptionStatus } from '../../types/Subscription';

export const ACTIVE_SUBSCRIPTION_STATUSES: readonly SubscriptionStatus[] = [
    SubscriptionStatus.ACTIVE,
    SubscriptionStatus.TRIAL,
    SubscriptionStatus.SUSPENDED,
    SubscriptionStatus.GRACE_PERIOD,
    SubscriptionStatus.INTERNAL_TRIAL,
] as const;
